export default {
  skillStatus: {
    Validated: 'Validé',
    InProgress: 'En cours',
    NotDiscovered: 'À travailler',
    Blocked: 'Bloquée',
  },
  // SchoolModulesPage.vue
  schoolModulesPage: {
    recommended: 'conseillé',
    verifyLevel: 'Vérifions votre niveau avec quelques défis.',
    takeTest: 'Passer le test',
    setAsDefault: 'Définir comme niveau par défaut',
    confirmChange: 'Confirmez-vous ce choix ? Si vous changez de niveau principal, j\'adapterai mes recommandations en fonction.',
    cancel: 'Annuler',
    yesChange: 'Oui, je change de niveau',
    recommendedModule: 'Module recommandé',
    recommendedModules: 'Modules recommandés',
    otherModules: 'Autres modules',
    finishedModulesList: 'Liste des modules terminés pour ce niveau',
    testProfileReminder: 'Vous pourrez retrouver le test à tout moment dans votre profil.',
    modules: 'modules',
    banners: {
      finish: "Bravo, vous avez terminé toutes les compétences de votre niveau !",
      next: "Niveau suivant",
      test: "Vérifions votre niveau avec quelques défis.",
      goToTest: "Passer le test",
    }
  },

  // SchoolModulePage.vue
  schoolModulePage: {
    congratulations: 'Bravo !',
    moduleFinished: 'Vous avez fini ce module !',
    keepGoing: 'Continuez comme ça et vous serez bientôt capable de jouer vos morceaux préférés',
    backToList: 'Retour à la liste des modules',
    letsGo: 'C\'est parti !'
  },

  // SchoolModulesHeaderBar.vue
  schoolModulesHeaderBar: {
    level: 'Niveau {level}',
    learningPath: 'Parcours {level}',
    modulesCount: '{finished} / {total} modules'
  },

  // SchoolModuleStepView.vue
  schoolModuleStepView: {
    or: 'ou'
  },

  // SchoolLevelUpPopup.vue
  schoolLevelUpPopup: {
    congratulations: 'Félicitations !',
    finishedAllModules: 'Vous avez terminé tous les modules {level} !',
    finishedAllSkillsForLevel: 'Vous avez terminé toutes les compétences du niveau {level} !',
    finishedAllModulesForLevel: 'Vous avez terminé tous les modules {level} !',
    readyNextLevel: 'Prêt à passer au niveau supérieur ?',
    nextLevelQuestion: 'Prêt à passer au niveau supérieur ?',
    maxLevelReached: 'Vous pouvez maintenant jouer des challenges, apprendre un morceau ou bien réviser des modules de niveau inférieur. Nous ajoutons des modules régulièrement alors n\'hésitez pas à vérifier s\'il y en a de nouveaux de temps en temps.',
    maxLevelSkills: 'Vous pouvez maintenant jouer des challenges, apprendre un morceau ou bien réviser des compétences de niveau inférieur. Nous ajoutons des compétences régulièrement alors n\'hésitez pas à vérifier s\'il y en a de nouvelles de temps en temps.',
    pieces: 'Morceaux',
    challenges: 'Challenges',
    nextLevel: 'Niveau superieur',
    close: 'Fermer',
    levelUpNotification: 'Félicitations ! Vous êtes maintenant niveau {level}',
    levelUpMessage: 'Félicitations ! Vous êtes maintenant au niveau supérieur !'
  },

  // SchoolVideoPopup.vue
  schoolVideoPopup: {
    skip: 'Passer',
    validate: 'Valider',
    cancel: 'Annuler'
  },

  // SchoolChallengePopup.vue
  schoolChallengePopup: {
    close: 'fermer',
    premiumOnly: 'Tous les challenges de cette étape sont disponibles uniquement avec l\'abonnement premium !',
    skipStep: 'Passer l\'étape',
    alreadyCompleted: 'Vous avez déjà complété ce challenge ! Voulez vous le rejouer ou passer à l\'étape suivante ?',
    mustComplete: 'Vous n\'avez pas complété ce challenge, vous devez le compléter pour passer à la suite !',
    replay: 'Rejouer',
    play: 'Jouer',
    validate: 'Valider'
  },

  // SkillCategories.vue (aucun texte visible à traduire - textes dans SkillCard)

  // SkillCard.vue
  skillCard: {
    videos: '{count} vidéo{plural}',
    skills: '{count} compétence{plural}',
    statusNotDiscovered: 'À travailler',
    statusDiscovered: 'Découvert',
    statusInProgress: 'En cours',
    statusValidated: 'Validé',
    statusBlocked: 'Bloquée'
  },

  skillCategories: {
    filterByHand: 'Filtrer par main :',
    allHands: 'Toutes les mains',
    leftHand: 'Main gauche',
    rightHand: 'Main droite',
    bothHands: 'Mains ensemble'
  },

  // SkillListPage.vue
  skillListPage: {
    loadingSkills: 'Chargement des compétences...',
    noSkills: 'Aucune compétence disponible pour cette catégorie',
    skillsCount: '{count} compétence{plural}',
    seeMore: 'Voir plus',
    seeLess: 'Voir moins'
  },

  // SkillDetailPage.vue
  skillDetailPage: {
    loadingContent: 'Chargement du contenu...',
    foundIn: 'Je retrouve cette compétence dans :',
    exercises: 'exercice | exercices',
    pieces: 'morceau | morceaux',
    challenges: 'challenge | challenges',
    workOnSkill: 'Travailler cette compétence',
    skillDifficultyHigher: 'Cette compétence est plus difficile que votre niveau actuel.',
    noExerciseFound: 'Je n\'ai trouvé aucun exercice pour travailler cette compétence pour le moment.',
    videos: 'Vidéos',
    completedExercises: 'Exercices complétés',
    noCompletedExercises: 'Aucun exercice complété',
    validatedChallenges: 'Challenges validés',
    noCompletedChallenges: 'Aucun challenge complété',
    seeMore: 'Voir plus',
    seeLess: 'Voir moins',
    associatedPieces: 'Morceaux associés',
    noPiecesAvailable: 'Aucun morceau disponible',
    suggestedExercise: 'Exercice suggéré',
    otherExercises: 'Autres exercices',
    noExercisesAvailable: 'Aucun exercice disponible',
    otherChallenges: 'Autres challenges',
    noChallengesAvailable: 'Aucun challenge disponible',
    blockedSkill: "Cette compétence est actuellement bloquée car certaines compétences nécessaires ne sont pas encore validées. Elle se débloquera automatiquement au fur et à mesure de votre progression."
  },

  // VideoListPage.vue
  videoListPage: {
    loadingSkills: 'Chargement des compétences...',
    noVideos: 'Aucune vidéo disponible pour cette catégorie',
    videosCount: '{count} vidéo{plural}'
  },

  // VideoCard.vue
  videoCard: {
    watchAgain: 'Revoir la vidéo',
    watch: 'Voir la vidéo'
  },

  // VideoDetail.vue
  videoDetail: {
    watchLater: 'Revoir plus tard',
    validate: 'Valider',
    ok: 'Ok'
  },

  // SkillBreadcrumbNavigation.vue
  skillBreadcrumbNavigation: {
    categories: 'Catégories'
  },

  // SchoolModuleSteps.ts - Exercise types
  exerciseTypes: {
    handprint: 'Empreinte',
    pianisticTechnic: 'Technique pianistique',
    rhythmic: 'Rythmique',
    sequence: 'Enchainement'
  }
}